export const locationsIusa = [
  {
    coordinates: [19.3942621, -99.239155],
    title: 'Lomas Altas',
    description: 'Av. Paseo de la Reforma 2608, Lomas Altas, Miguel Hidalgo, 11950 Ciudad de México, CDMX.',
  },
  {
    coordinates: [19.6592809, -99.7970589],
    title: 'IUSA Pasteje',
    description: 'Carr. Panamericana Méx - Qro Km. 109, 50700, Jocotitlán.',
  },
  {
    coordinates: [19.4746466, -99.1028447],
    title: 'Grupo IUSA Aragón',
    description: 'Ote. 171 398, Pueblo de San Juan de Aragón, Gustavo A. Madero, 07470 Ciudad de México, CDMX.',
  },
  {
    coordinates: [19.3508709, -99.0793453],
    title: 'IUSA IZTAPALAPA SA DE CV',
    description: 'Cam. Real a San Lorenzo 284, San Miguel 8a ampliación, Iztapalapa, 09837 Ciudad de México, CDMX.',
  },
  {
    coordinates: [16.8641322, -99.8796233],
    title: 'ACAPULCO',
    description: 'Alonso Martín No. 57 Fracc. Magallanes, Acapulco Gro, C.P. 39680.',
  },
  {
    coordinates: [19.1112458, -98.2634415],
    title: 'Puebla',
    description: 'Av. San Lorenzo Núm. 803, Parque Empresarial Cuautlancingo, Cuautlancingo Puebla C.P. 72730.',
  },
  {
    coordinates: [17.0786453, -96.7163323],
    title: 'OAXACA',
    description: 'Heroica Escuela Naval Militar No 401-Int 1, Reforma, 68050 Oaxaca de Juárez, Oax.',
  },
  {
    coordinates: [19.0827146, -96.1602968],
    title: 'VERACRUZ',
    description: 'Carretera Veracruz-El Tejar KM 6.5 Col. Teresa Morales de Delgado, El Tejar Mpio. de Medellín, Ver. C.P. 94273.',
  },
  {
    coordinates: [21.1698162, -101.6567031],
    title: 'LEÓN',
    description: 'Blvd. José María Morelos #608 Col. San José del Consuelo, León, Guanajuato, C.P. 37200.',
  },
  {
    coordinates: [22.1350375, -100.9291653],
    title: 'SAN LUIS POTOSÍ',
    description: 'Manuel Ortíz de Santa María No. 115-B Col. Estrella de Oriente, Zona de Abastos, San Luis Potosí, S.L.P. C.P. 78396.',
  },
  {
    coordinates: [29.0943697, -110.9591537],
    title: 'HERMOSILLO',
    description: 'Ave. Nayarit #84 Interior G3 Entre Gral. Jose Maria Yañez Y Gral. Mariano Escobedo Col. San Benito, Hermosillo, Sonora CP. 83190.',
  },
  {
    coordinates: [19.6904611, -101.1632337],
    title: 'MORELIA',
    description: 'Gral. Amado Camacho No. 556 Int. 2 Col. Chapultepec Oriente, Morelia, Michoacán C.P. 58260.',
  },
  {
    coordinates: [16.7617848, -93.1141262],
    title: 'TUXTLA GUTIÉRREZ',
    description: '9ª. Norte oriente 103-10 Col. Centro Tuxtla Gutiérrez, Chiapas, C.P. 29000.',
  },
  {
    coordinates: [32.4934602, -116.8991083],
    title: 'TIJUANA',
    description: 'Andador del Rey No 20051 Parque Ind. Girasol Plataforma 8, nave D, Colonia Rancho el Águila Tijuana B.C. C.P. 22215.',
  },
  {
    coordinates: [25.7438211, -109.0110983],
    title: 'LOS MOCHIS',
    description: 'Calle Los Granjeros No. 662 Ote. local 6 y 7 sector Punto Verde. Los Mochis, Sinaloa, C.P. 81290.',
  },
  {
    coordinates: [28.7199127, -106.1372131],
    title: 'CHIHUAHUA',
    description: 'Calle Luis G. Urbina No. 113 Col. Complejo Industrial Chihuahua, Chihuahua, Chih. C.P. 31109.',
  },
  {
    coordinates: [20.6418515, -103.3526346],
    title: 'GUADALAJARA',
    description: 'Avenida Lázaro Cárdenas No. 37 Col. Zona Industrial Guadalajara, Jal. C.P. 44940.',
  },
  {
    coordinates: [21.0651579, -89.6402698],
    title: 'MÉRIDA',
    description: 'Calle 60 No. 477, Nave 3 Parque Industrial No Contaminantes Mérida, Yucatán, C.P. 97302.',
  },
  {
    coordinates: [25.716434, -100.2495175],
    title: 'MONTERREY',
    description: 'Av. D No. 1035-1041 Col. Hacienda los Morales, San Nicolás de los Garza, N.L. C.P. 66495.',
  },
  {
    coordinates: [22.3096925, -97.8782189],
    title: 'TAMPICO',
    description: 'Emiliano Zapata No. 514, Col. Nuevo Progreso Tampico, Tamps. C.P. 89318.',
  },
  {
    coordinates: [21.1388021, -86.8627288],
    title: 'CANCÚN',
    description: 'Av. Nichupte Smz. 512 Mz 10 Lote 1-01-A, Depto. 401, privada Residencial Nichupté Cancún, Quintana Roo, C.P. 77534.',
  },
  {
    coordinates: [18.024805, -92.9144615],
    title: 'VILLAHERMOSA',
    description: 'Cerrada de Antimonio S/N Bodega 7 Cd. Industrial Villahermosa, Tabasco, C.P. 86010.',
  },
];

export const videosIusa = [
  {
    youtubeUrl: 'https://www.youtube.com/embed/xwDF_kVQyic?si=-0svLf9WGWJDne5n',
    title: 'GRUPO IUSA',
    description: 'Reconocemos a nuestra gente por el éxito de nuestra empresa. Por eso, nuestra principal apuesta es el éxito de nuestra gente.',
    href: 'https://www.youtube.com/watch?v=xwDF_kVQyic',
  },
  {
    youtubeUrl: 'https://www.youtube.com/embed/X0zQUw6t6qk',
    title: 'IUSA Sistemas integrales para la construcción',
    description: 'Nos respaldan más de 80 años de experiencia de Grupo IUSA, ofreciendo calidad, servicio e innovación tecnológica 100% mexicana.',
    href: 'https://www.youtube.com/watch?v=X0zQUw6t6qk',
  },
  {
    youtubeUrl: 'https://www.youtube.com/embed/CIiY3jS_We0',
    title: 'IUSASOL',
    description: 'IUSASOL® se perfila a convertirse en la empresa líder en el suministro y comercialización de electricidad limpia y renovable en México.',
    href: 'https://www.youtube.com/watch?v=CIiY3jS_We0',
  },
];
